module.exports = __webpack_public_path__ + "8ecbbb25784c72b382670b44f8e8b812.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/beers/images/exclusive_blue.png
// module id = MRJK
// module chunks = 0